module.exports = __webpack_public_path__ + "img/tool-know.ce47e7f.webp";